
import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import bg from 'assets/images/home/bg7.png'
import avatarPlaceholder from 'assets/images/user_placeholder.png'
import AuthLayout from 'layouts/authLayout/AuthLayout'
import { type UserProfile } from 'models'

import './_verificationCode.scss'
import VerificationModel from './VerificationModel'

type TwoFactorType = 'qr_authenticator' | 'sms'

type Props = {
  challenge: string
  twoFactorType: TwoFactorType
  showBack?: boolean
  onBack?: () => void
  onSuccess: (token: string, userProfile: UserProfile) => void
}

const VerificationModalWrapper = ({
  challenge,
  twoFactorType,
  showBack = false,
  onBack,
  onSuccess
}: Props) => {
  const { t } = useTranslation()
  const [isMobileView, setIsMobileView] = useState(
    () => window.innerWidth <= 768
  )

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobileView(window.innerWidth <= 768)
    }

    window.addEventListener('resize', checkIsMobile)

    return () => {
      window.removeEventListener('resize', checkIsMobile)
    }
  }, [])

  const content = (
    <div className='auth-verify'>
      <h1 className='auth-verify__title'>
        {t('twoStepAuthentication')}
      </h1>

      <div className='auth-verify__form'>
        <VerificationModel
          challenge={challenge}
          twoFactorType={twoFactorType}
          showBack={showBack}
          onBack={onBack}
          onSuccess={onSuccess}
        />
      </div>
    </div>
  )

  if (isMobileView) {
    return (
      <AuthLayout bgImg={bg} logo={avatarPlaceholder}>
        {content}
      </AuthLayout>
    )
  }

  // Desktop: reuse the existing login modal container.
  // Do not create another overlay or modal.
  return content
}

export default VerificationModalWrapper
